<template>
  <div class="login">
    <div class="code-login">
      <div id="wx_reg" />
    </div>
  </div>
</template>

<script>
export default {
  name: "login",

  data() {
    return {
      imgUrl: "/admin/v1/login?" + new Date().getTime(),
    };
  },
  created() {
    let ssotoken = this.$route.query.token;
    localStorage.setItem("wxtoken", ssotoken);
    if (ssotoken) {
      this.$cookies.set(
        "token",
        ssotoken,
        60 * 60 * 24,
        null,
        process.env.NODE_ENV === "development" ? null : ".gaodun.com"
      );
      this.$router.push("/home");
    }
  },
  mounted() {
    this.$nextTick(() => {
      let result = this.isWxBrowser();

      if (result) {
        this.$router.replace({
          path: "/home",
        });
      } else {
        this.createQrLoginBox();
      }
    });
  },
  beforeDestroy() {
    if (document.getElementById("wxLogin")) {
      document.body.removeChild(document.getElementById("wxLogin"));
    }
  },
  methods: {
    isWxBrowser() {
      var ua = navigator.userAgent.toLowerCase();
      let isWx = ua.match(/wxwork/i);

      if (!isWx) {
        return false;
      } else {
        return true;
      }
    },

    getveriityCode() {
      this.imgUrl = "/admin/v1/login?" + new Date().getTime();
    },

    createQrLoginBox() {
      let wxLogin = document.getElementById("wxLogin");
      if (!wxLogin) {
        let script = document.createElement("script");
        script.id = "wxLogin";
        script.src =
          "//rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js";
        document.body.appendChild(script);
        script.onload = function () {
          let href =
            "https://sso.server.gaodun.com/index/v1/workwxlogin?url=" +
            encodeURIComponent(window.location.href);
          window.WwLogin({
            id: "wx_reg",
            appid: "ww3e4fc9b495ff0fd8",
            agentid: "1000109",
            redirect_uri: encodeURIComponent(href),
            state: "gaodun",
          });
        };
      }
    },
  },
};
</script>

<style lang="less" scoped>
#wx_reg {
  text-align: center;
  padding-top: 100px;
  box-sizing: border-box;
}
.login {
  width: 100%;
  height: 100vh;
  background-color: #2d434c;
  overflow: hidden;
  .el-form {
    background-color: #fff;
    width: 400px;
    padding: 20px;
    padding-top: 80px;
    margin: 0 auto;
    margin-top: 150px;
    border-radius: 5px;
    position: relative;
    .resetBtn {
      margin-left: 70px;
    }
  }
}
</style>
<style lang="less">
.login {
  .veriity {
    .el-form-item__content {
      width: 320px;
      height: 33px;
      border: 1px solid #dcdfe6;
      margin-bottom: 20px;
      border-radius: 4px;
    }
    .el-input {
      border-radius: 4px;
      width: 200px;
      position: relative;
      overflow: hidden;
    }
    .el-input__inner {
      border: none;
    }
    .veriityCode {
      position: absolute;
      top: 1px;
      right: 0;
      height: 32px;
      cursor: pointer;
    }
  }
}
</style>
